// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1lYnl","footer":"ReportModalFilter_footer__3AzSM"};